module.exports = __webpack_public_path__ + "img/design.f7189b01.svg";